import { BaseClient } from '../client';
import { UserMock } from '../user/user.mocks';

interface PutAdminUserRequest {
	idGrupoAcesso: number;
	concessionarias: number[];
	idRevenda: number;
	nome: string;
	email: string;
	telefone: string;
	senha: string;
	tagAtivo: string;
	tagNaoComprar: string;
	tagReceberEmail: string;
	tagReceberPush: string;
}

export const putAdmintUser = async (id: string, requestBody: PutAdminUserRequest) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return { ...UserMock, nome: 'Nome alterado', email: 'Email alterado' };
	// }

	try {
		const response = await BaseClient.put<string>(
			`/Admin/UpdateAdminUsuario/${id}`,
			requestBody
		).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
